import React from 'react';
import PropTypes from 'prop-types';

function IconForward({ color = '#B3B3B3', size = 20, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5L14 10L8 15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

IconForward.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string
}

export default IconForward;
